import { Progress } from '@chakra-ui/react';
import dynamic from 'next/dynamic';

const LoadingBar = () => (
  <Progress
    size="xs"
    isIndeterminate
    position="fixed"
    top="0"
    left="0"
    width="100%"
    zIndex="1000"
    colorScheme="blue"
  />
);

export function dynamicWithLoading(importFunc: Parameters<typeof dynamic>[0]) {
  return dynamic(importFunc, {
    loading: () => <LoadingBar />,
  });
}
